import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthClientConfig } from '@auth0/auth0-angular';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {
  id: string = '';
  responseJson: string = '';
  hasApiError = false;
  apiError: string = '';

  constructor(
    private api: ApiService,
    private configFactory: AuthClientConfig,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.id = id;
      this.api.getUsersId$(this.id).subscribe({
        next: (res: any) => {
          this.hasApiError = false;
          this.responseJson = JSON.stringify(res, null, 2).trim();
        },
        error: () => this.hasApiError = true,
      });
    }
  }
}
